/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Root export for the location module
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { type Actions, locationReducer as rootReducer } from './reducers'

// This satisfies makes sure that everything in the whitelist is also used in the reducer
const allowedList = Object.values(constants) satisfies ReadonlyArray<Actions['type']>

// These 2 lines make sure that every action type that the reducer uses is included in the whitelist
declare const shouldBeEmpty: Exclude<Actions['type'], (typeof allowedList)[number]>
false && (shouldBeEmpty satisfies never)

export { allowedList }
export const locationReducer = filterActions(rootReducer, allowedList)
